var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTailan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.21,
    y: 389.21,
    width: 25.46,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 394.62,
    width: 60.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.46,
    y: 389.33,
    width: 62.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 396.81,
    width: 13.04,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.71,
    y: 396.81,
    width: 59.38,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 392.59,
    width: 38.45,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.66,
    y: 82.77,
    width: 179.29,
    height: 62.45,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 27.76,
    width: 55.63,
    height: 172.47,
    transform: "translate(292.3 -64.32) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.25,
    y: 83.47,
    width: 3.41,
    height: 61.04,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.36,
    y: 86.18,
    width: 18.89,
    height: 55.63,
    transform: "translate(275.61 227.98) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.94,
    y: 86.18,
    width: 18.89,
    height: 55.63,
    transform: "translate(392.76 227.98) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.66,
    y: 86.18,
    width: 18.89,
    height: 55.63,
    transform: "translate(510.2 227.98) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.83,
    y: 83.47,
    width: 3.41,
    height: 61.04,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.69,
    y: 82.77,
    width: 16.98,
    height: 62.45,
    transform: "translate(160.35 227.98) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.54 141.81 104.1 141.81 111.48 94.37 142.92 94.37 135.54 141.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.98 141.81 165.54 141.81 171 94.37 202.44 94.37 196.98 141.81",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.96 141.81 153.36 141.81 165.39 98.66 193.99 98.66 181.96 141.81",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.07,
    y: 90.54,
    width: 31.44,
    height: 51.27,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.21,
    y: 90.54,
    width: 31.44,
    height: 51.27,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.39 141.81 211.03 141.81 219.5 98.66 243.86 98.66 235.39 141.81",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.26 141.81 209.24 141.81 209.24 101.79 236.66 101.79 223.26 141.81",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.49,
    y: 90.54,
    width: 7.16,
    height: 51.27,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.45,138h0a.94.94,0,0,1-.94-.94V95.32a.94.94,0,0,1,.94-.95h0a.94.94,0,0,1,1,.95V137A.94.94,0,0,1,114.45,138Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.37,
    y: 145.22,
    width: 179.29,
    height: 62.45,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.21,
    y: 90.2,
    width: 55.63,
    height: 172.47,
    transform: "translate(413.46 -60.58) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.96,
    y: 145.92,
    width: 3.41,
    height: 61.04,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.07,
    y: 148.63,
    width: 18.89,
    height: 55.63,
    transform: "translate(393.03 352.88) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.65,
    y: 148.63,
    width: 18.89,
    height: 55.63,
    transform: "translate(510.18 352.88) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.37,
    y: 148.63,
    width: 18.89,
    height: 55.63,
    transform: "translate(627.62 352.88) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.55,
    y: 145.92,
    width: 3.41,
    height: 61.04,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.4,
    y: 145.22,
    width: 16.98,
    height: 62.45,
    transform: "translate(277.77 352.88) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.71 204.25 221.27 204.25 228.66 156.81 260.09 156.81 252.71 204.25",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.41 204.25 282.97 204.25 288.43 156.81 319.87 156.81 314.41 204.25",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.38 204.25 270.79 204.25 282.82 161.1 311.42 161.1 299.38 204.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.24,
    y: 152.98,
    width: 31.44,
    height: 51.27,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 152.98,
    width: 31.44,
    height: 51.27,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.93 204.25 152.56 204.25 161.03 161.1 185.4 161.1 176.93 204.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.8 204.25 150.78 204.25 150.78 164.24 178.19 164.24 164.8 204.25",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.03,
    y: 152.98,
    width: 7.16,
    height: 51.27,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.63,200.42h0a.94.94,0,0,1-.95-.95V157.76a1,1,0,0,1,.95-.95h0a1,1,0,0,1,.94.95v41.71A.94.94,0,0,1,231.63,200.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.76,118.22V131A14.31,14.31,0,0,0,295,145.22h0A14.31,14.31,0,0,0,309.29,131V118.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.12,
    y: 287.38,
    width: 89.15,
    height: 10.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.04,
    y: 297.77,
    width: 83.23,
    height: 68.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.27,
    y: 297.77,
    width: 200.69,
    height: 68.05,
    transform: "translate(583.23 663.59) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.04,
    y: 297.77,
    width: 283.92,
    height: 3.84,
    transform: "translate(500 599.39) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.27,
    y: 287.38,
    width: 206.61,
    height: 10.39,
    transform: "translate(589.15 585.15) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.04 365.82 108.04 382.4 124.62 365.82 108.04 365.82",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.27 365.82 191.27 382.4 207.85 365.82 191.27 365.82",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.96 365.82 391.96 382.4 375.38 365.82 391.96 365.82",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.27 365.82 191.27 382.4 174.69 365.82 191.27 365.82",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.73 365.82 308.73 382.4 292.15 365.82 308.73 365.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.73 365.82 308.73 382.4 325.31 365.82 308.73 365.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.09 250.53 239.04 284.86 212.87 284.86 211.94 287.38 238.59 287.38 254.89 287.38 299.16 287.38 305.66 250.53 245.09 250.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.49,
    y: 102.6,
    width: 70.76,
    height: 117,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.66,
    y: 102.6,
    width: 70.76,
    height: 117,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.26 185.36 386.94 185.36 392.81 136.85 399.13 136.85 393.26 185.36",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.98 185.36 403.66 185.36 409.53 136.85 415.85 136.85 409.98 185.36",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.55 185.36 370.23 185.36 376.1 136.85 382.42 136.85 376.55 185.36",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-6",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "148.58 406.89 156.01 406.89 156.33 389.68 148.9 389.68 148.58 406.89",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.98 406.89 111.41 406.89 114.72 389.68 107.29 389.68 103.98 406.89",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.91,406h-8.34a.62.62,0,0,0-.62.5l-1.31,6.61a1.12,1.12,0,0,0,1.12,1.32c2.91,0,4.32-.22,8-.22,2.26,0,6.92.23,10,.23s3.45-3.08,2.16-3.36c-5.75-1.25-8-3-9.82-4.63A1.88,1.88,0,0,0,111.91,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.94,406h-8.11a.62.62,0,0,0-.62.5l-1.31,6.61a1.11,1.11,0,0,0,1.1,1.32c2.93,0,7.15-.22,10.83-.22,4.3,0,4.75.23,9.8.23,3.05,0,3.82-3.08,2.53-3.36-5.84-1.27-7.32-1.41-12.42-4.5A3.46,3.46,0,0,0,155.94,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,171.91l10.14-3.25s10.47,24.26,14,25.77c4.78,2,11.45,8.53,16.18,12.48.16,1.25-.43,4.54-1.17,5.4-8.56-2-19.21-6.9-22.71-10.13C162.47,194.81,154,171.91,154,171.91Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.64,166.33c-2.85,6.5,8.59,27.14,8.59,27.14l15.16-7a94.49,94.49,0,0,0-7.51-18.14C163.11,160,154.77,159.19,151.64,166.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.9,181.83c-3.31-4.57-8.68-5.86-13.46-6.1,2.48,8.17,7.8,17.74,7.8,17.74l8.65-4A15.43,15.43,0,0,0,165.9,181.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,206.19l8.83,1.41-2.28,9.33a33,33,0,0,1-8.52-5.3Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.79 211.55 206.56 216.69 199.85 216.93 202.13 207.6 209.79 211.55",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.33 389.69 156.16 398.56 148.73 398.56 148.9 389.69 156.33 389.69",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.28 389.69 114.72 389.69 113.01 398.56 105.57 398.56 107.28 389.69",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.35,162.11s8.22,23.3,2,67.31H123.62c-.42-6.1,2.68-38.95-3.9-67.69A101.82,101.82,0,0,1,133,160.05a146.31,146.31,0,0,1,16.89,0A76.15,76.15,0,0,1,161.35,162.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.45 189.52 131.97 189.52 131.71 182.29 143.19 182.29 143.45 189.52",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.72 189.23 132.24 189.23 131.71 182.29 143.19 182.29 143.72 189.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.16 186.58 133.03 186.58 132.78 183.44 135.92 183.44 136.16 186.58",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.54 184.96 136.9 184.96 136.85 184.34 142.49 184.34 142.54 184.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.45 186.18 137 186.18 136.95 185.55 141.4 185.55 141.45 186.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.27 187.97 133.13 187.97 133.09 187.34 136.22 187.34 136.27 187.97",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.13 187.97 142.77 187.97 142.72 187.34 137.09 187.34 137.13 187.97",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.56,183.58h0a.66.66,0,0,1-.65-.61l-.11-1.37a.57.57,0,0,1,.56-.61h0a.66.66,0,0,1,.65.61l.11,1.37A.55.55,0,0,1,137.56,183.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.52,168.83c.78,4.73-.43,16-4.62,29.12a190.39,190.39,0,0,0-3.56-33.36v-.06C123,164.27,127.78,164.39,128.52,168.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.8,144.25c1.2,5.44,1.89,12.17-1.82,15.8,0,0,2.32,5.51,12.42,5.51,9.22,0,4.47-5.51,4.47-5.51-6.1-1.45-6-8.94-5-13.16Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.39,164.59l2.91,3.23s0,0,0,0l-.74,2.26a.93.93,0,0,1-.85.64l-2,.1a1,1,0,0,1-.84-.42l-1.59-2.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.39,164.59a49.62,49.62,0,0,0-3.35,6.26s-12.12-4.29-11.68-10.82a30.71,30.71,0,0,0,3.79-2.18S134.68,162,145.39,164.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.39,164.59a25.12,25.12,0,0,1,3.76,5.8,10.16,10.16,0,0,0,2.6-10.34,21.52,21.52,0,0,0-3.26-1S149.34,163.19,145.39,164.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.48,169.62c.3-.12,5.27,25.23,6,31.44,1.45,8.27-2.44,17.4-2.45,17.38a65,65,0,0,1-3.57-17.82c-.57-10.56-.82-24.91-1.78-31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.86,146.89a16.3,16.3,0,0,0,.26,8.92,9.8,9.8,0,0,1-2.73-.83c-3.45-1.61-5.2-4.14-7-7.91-.16-1-.35-1.9-.55-2.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,127.78l2.75,8.83A5.35,5.35,0,0,0,147,127.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.23,137.63c2.14,7.12,3,11.4,7.53,14.32,6.74,4.39,14.76-.83,14.75-8.41,0-6.82-3.51-17.32-11.18-18.68A9.83,9.83,0,0,0,130.23,137.63Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.12,143c2-1.3,2.83-8,1-10.34,6.41-.29,9.58-2.46,9.75-3.63,2.25,1,7.87,1.38,7.16-1.46a6.25,6.25,0,0,0-5-4.45c-2.21-2.34-7.75-4.3-11.66-1.13-6.84,0-10.46,5.5-8.55,7.67a5.36,5.36,0,0,0,0,9.25C124,141.67,131.91,147.82,133.12,143Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89,146.29a7.07,7.07,0,0,0,5,2.11c2.45,0,3-2.35,1.71-4.33-1.14-1.79-3.79-3.95-6-3S127.28,144.64,128.89,146.29Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.24,229.42s.79,9.34,1.8,22c1.14,14.35,2.55,33,3.4,47.17,0,.08,0,.14,0,.2.16,2.69.3,5.22.41,7.53,1.13,23.15,3.45,90.52,3.45,90.52h12.58s6.34-68.75,6.6-92.31c.26-22.66-2.13-75.11-2.13-75.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.38,393c-.06,0,.1,4.11.1,4.11H160l.49-4.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,251.42c1.14,14.35,2.55,33,3.4,47.17,0,.08,0,.14,0,.2,3.08-13.46,4.32-30.2,3.89-57.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.26,229.42s-7,53.68-11.14,75c-4.5,23.29-21.69,92.47-21.69,92.47H102.82s10.74-67.3,13.06-90.36c2.53-25,7.74-77.06,7.74-77.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.73,393.29s-.58,3.8-.58,3.8H117.1l1.22-4.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.52,137.29c.14.59.56,1,.94.92s.58-.63.44-1.21-.56-1-.94-.92S141.39,136.71,141.52,137.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.09,135.87c.14.58.56,1,.94.91s.57-.62.44-1.21-.56-1-.94-.92S148,135.28,148.09,135.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.07,136.61a22.34,22.34,0,0,0,4,4.43,3.37,3.37,0,0,1-2.65,1.13Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.29,144.45a.18.18,0,0,0,.12-.22.17.17,0,0,0-.21-.12,4.8,4.8,0,0,1-4.21-.88.17.17,0,0,0-.25,0,.16.16,0,0,0,0,.24A5.06,5.06,0,0,0,146.29,144.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,135.58a.35.35,0,0,0,.24-.19,2.71,2.71,0,0,1,1.91-1.63.35.35,0,0,0,.29-.4.36.36,0,0,0-.4-.3,3.34,3.34,0,0,0-2.44,2,.36.36,0,0,0,.18.47A.34.34,0,0,0,139,135.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48,132.87a.29.29,0,0,0,.14-.08.34.34,0,0,0,0-.49,3.53,3.53,0,0,0-3-1.23.34.34,0,0,0-.29.4.35.35,0,0,0,.4.3h0a2.8,2.8,0,0,1,2.36,1A.36.36,0,0,0,150.48,132.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.24,170.17l10,4.14s-7.38,21.3-7.92,24.69c4.05,1.5,8.5,7.53,13.9,11.47-.14,1.22-2.48,4.22-3.42,4.87-8.06-3.91-20.42-9.32-21-14C105.38,190.84,115.24,170.17,115.24,170.17Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.81,210l8.37,0-2.39,8.24s-5.17-.31-8.23-4.1Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.19 211.65 139.65 219 134.79 218.3 137.18 210.06 142.19 211.65",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.72,161.73c-7,1-14.46,25.38-14.46,25.38l16.13,6.11a146,146,0,0,0,8-18C132.58,166.25,127.23,160.63,119.72,161.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.4,407.32a2.21,2.21,0,0,0,1.42-.37,1,1,0,0,0,.34-.94.55.55,0,0,0-.31-.49c-.82-.42-3.19,1.05-3.46,1.22a.17.17,0,0,0-.08.18.22.22,0,0,0,.14.14A9.12,9.12,0,0,0,114.4,407.32Zm1.07-1.53a.53.53,0,0,1,.23,0,.24.24,0,0,1,.11.21.7.7,0,0,1-.22.64,3.61,3.61,0,0,1-2.64.13A6.88,6.88,0,0,1,115.47,405.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.49,407.06a.11.11,0,0,0,.08,0c.76-.42,2.21-2,2-2.87a.59.59,0,0,0-.57-.46.91.91,0,0,0-.74.22c-.85.71-1,2.85-1,2.94a.17.17,0,0,0,.09.16A.14.14,0,0,0,112.49,407.06Zm1.43-3H114c.23,0,.25.13.26.17.1.49-.81,1.72-1.56,2.3a4.11,4.11,0,0,1,.82-2.33A.6.6,0,0,1,113.92,404.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.06,407.32a2.8,2.8,0,0,0,1.8-.45,1,1,0,0,0,.3-.86.57.57,0,0,0-.3-.47c-.91-.5-3.86,1-4.19,1.19a.16.16,0,0,0-.09.18.18.18,0,0,0,.14.15A13.16,13.16,0,0,0,159.06,407.32Zm1.31-1.53a.75.75,0,0,1,.33.06.22.22,0,0,1,.11.19.64.64,0,0,1-.19.57c-.45.4-1.67.47-3.32.2A9.54,9.54,0,0,1,160.37,405.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.75,407.06h.08c.88-.41,2.62-2,2.46-2.85,0-.2-.18-.45-.66-.49a1.2,1.2,0,0,0-1,.3c-.93.77-1.08,2.77-1.09,2.86a.21.21,0,0,0,.08.16A.19.19,0,0,0,156.75,407.06Zm1.74-3h.11c.32,0,.34.15.35.19.09.51-1.09,1.77-2,2.32a4,4,0,0,1,.93-2.29A.92.92,0,0,1,158.49,404.05Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Report--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.48,
    y: 139.72,
    width: 4.67,
    height: 1,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.07,
    y: 139.72,
    width: 19.25,
    height: 1,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.37,318.63H198.46a10.77,10.77,0,0,1-10.54-9.86l-10.7-155.69a9.12,9.12,0,0,1,9.18-9.86H307.3a10.75,10.75,0,0,1,10.54,9.86l10.7,155.69A9.1,9.1,0,0,1,319.37,318.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.23,315.34a7.15,7.15,0,0,1-7-6.57L180.5,153.08a6.06,6.06,0,0,1,6.12-6.57H307.53a7.16,7.16,0,0,1,7,6.57l10.71,155.69a6.06,6.06,0,0,1-6.12,6.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.51,223.58H202.58l-4.13-60.19H308.37Zm-109.16-.82H311.63l-4-58.55H199.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.6 172.69 199.5 172.69 199.44 171.87 308.54 171.87 308.6 172.69",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.18 181.17 200.08 181.17 200.02 180.35 309.13 180.35 309.18 181.17",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.77 189.66 200.66 189.66 200.6 188.83 309.71 188.83 309.77 189.66",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.35 198.14 201.25 198.14 201.19 197.31 310.29 197.31 310.35 198.14",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.93 206.62 201.83 206.62 201.77 205.8 310.88 205.8 310.93 206.62",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.52 215.1 202.41 215.1 202.35 214.28 311.46 214.28 311.52 215.1",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.88 168.45 188.44 168.45 188.38 167.63 196.82 167.63 196.88 168.45",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.46 176.93 189.02 176.93 188.96 176.11 197.41 176.11 197.46 176.93",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.04 185.41 189.6 185.41 189.55 184.59 197.99 184.59 198.04 185.41",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.63 193.9 190.19 193.9 190.13 193.07 198.57 193.07 198.63 193.9",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.21 202.38 190.77 202.38 190.71 201.56 199.16 201.56 199.21 202.38",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.79 210.86 191.35 210.86 191.3 210.04 199.74 210.04 199.79 210.86",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.38 219.34 191.94 219.34 191.88 218.52 200.32 218.52 200.38 219.34",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "203.2 223.52 202.74 222.81 215.75 214.94 219.78 210.91 228.66 203.08 237.85 206.51 247.16 190.97 260.01 194.34 276.5 183.46 284.75 186.94 306.38 176.15 306.79 176.89 284.83 187.84 276.63 184.39 260.2 195.23 247.59 191.91 238.24 207.52 228.88 204.02 220.36 211.53 216.25 215.63 203.2 223.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.28 223.45 202.65 222.89 215.22 208.6 218.81 200.46 230.91 207.43 236.34 194.16 246.85 184.5 260.23 192.04 276.04 176.98 287.32 183.69 305.59 166.1 306.18 166.71 287.48 184.71 276.2 178 260.4 193.06 247.01 185.51 236.98 194.72 231.35 208.6 219.22 201.62 215.9 209.12 203.28 223.45",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,266.72l9-30.4a35.36,35.36,0,0,1,23.38,30.4,29.84,29.84,0,0,1-24.54,31.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,266.72l7.81,31.87a32.45,32.45,0,0,1-5.59.49c-17.74,0-33.35-14.61-34.57-32.36a30,30,0,0,1,30.12-32.35,33.47,33.47,0,0,1,11.2,1.95Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.54 264.05 280.94 264.05 283.35 299.08 292.95 299.08 290.54 264.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.54 264.05 280.94 264.05 279.47 242.7 289.07 242.7 290.54 264.05",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.31 270.43 297.71 270.43 299.68 299.08 309.28 299.08 307.31 270.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.31 270.43 297.71 270.43 296.81 257.3 306.41 257.3 307.31 270.43",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.37,158.07c-1,4.9-1.92,13.89,1.51,17.16a24.91,24.91,0,0,1-11.82,10c-6.56-4.11-3.42-10-3.42-10,5.47-1.31,5.33-5.36,4.37-9.17Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.64,178.13c3.57-2.46,3.83-7.13,3.83-7.13s-13-3.33-20.08-1.33c-2.17,1.66-5.63,4.75-5.63,4.75s.88,2,4.88,3.26S365.64,178.13,365.64,178.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.75,181.92c2.44,3.52,4.63,7,6.71,10.69a115.39,115.39,0,0,1,5.76,11.31c.42,1,.85,2,1.23,3l.29.76.15.38.07.19.12.35a7.86,7.86,0,0,1,.37,2.85,11.27,11.27,0,0,1-1.2,4.29,19.11,19.11,0,0,1-1.94,3.13,40.79,40.79,0,0,1-9.66,8.9l-2.72-3.18a61.77,61.77,0,0,0,6.77-9.37,16.21,16.21,0,0,0,1-2.27,3.86,3.86,0,0,0,.26-1.65c0-.15-.06-.21-.09-.19h0l-.07-.16-.16-.33-.3-.67c-.4-.88-.86-1.75-1.29-2.63q-1.33-2.64-2.83-5.24c-1-1.74-2-3.47-3-5.18-2.09-3.41-4.27-6.87-6.43-10.15Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.37,223.73l-8.9-.67,4.92,6.81s5.27-.65,6.51-3.85Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.69 226.92 371.13 232.4 378.71 229.61 372.47 223.06 366.69 226.92",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.48,177l-5.66,7.72.41,9.53,9.61,8.72s4.93-3.51,9.22-7.06C385.68,183.58,380.82,178,377.48,177Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.43,184.32l-3,10.06,3.23,2.93C375.19,190.27,375.43,184.32,375.43,184.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.7,182.88c-.13,6,.71,18.45,4.92,44.35h33.56c-.56-13.66-1.23-22.22,5.3-50.26a93.15,93.15,0,0,0-13.6-1.74,107.54,107.54,0,0,0-15.24,0c-3.28.3-6.79.83-9.46,1.29A6.59,6.59,0,0,0,333.7,182.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.26,185.21l-6,9.73c.31,3.46.77,7.61,1.42,12.57l4.89-2.9C342.59,189.89,340.26,185.21,340.26,185.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.24,187.81c-1.35,4.65-2.79,9.27-4.28,13.87s-3,9.21-4.55,13.79l-.3.86-.48,1.12a18.86,18.86,0,0,1-1.09,2,20,20,0,0,1-2.74,3.42,26.64,26.64,0,0,1-6.65,4.81,41.84,41.84,0,0,1-14.8,4.25l-.69-4.13a53.85,53.85,0,0,0,6.39-2.41,36.18,36.18,0,0,0,5.84-3.24,21.38,21.38,0,0,0,4.65-4.11,12.16,12.16,0,0,0,1.58-2.36,9.34,9.34,0,0,0,.56-1.22l.2-.56.24-.86c1.24-4.65,2.52-9.27,3.88-13.88s2.68-9.21,4.15-13.78Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.26,183.25c-1.41-3.38-5.85-5.57-5.85-5.57-4.77,3.11-6.74,6.36-9.91,22.16,5.08,2.28,12.64,2.26,12.64,2.26l4.12-10.63S343.68,186.63,342.26,183.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.38,227.36l-8.34-.13,5.31,6.51s5.22-1,6.27-4.23Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.5 231.42 298.24 236.63 304.35 233.74 299.04 227.23 293.5 231.42",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.91,147.85c-.11.65-.56,1.12-1,1.05s-.68-.67-.56-1.33.56-1.13,1-1S345,147.19,344.91,147.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.53,146.59l-1.5-.73S343.62,147.23,344.53,146.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.63,143.74a.39.39,0,0,1,0-.72,3.91,3.91,0,0,1,3.58,0,.4.4,0,0,1,.13.54.38.38,0,0,1-.53.14,3.09,3.09,0,0,0-2.83,0A.37.37,0,0,1,344.63,143.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.86,150a17.77,17.77,0,0,1-3.08,3.78,2.86,2.86,0,0,0,2.26.85Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.54,149.07c-1.92,8-2.56,11.39-7.37,14.81-7.23,5.14-16.6,1-17.1-7.36-.44-7.55,2.77-19.32,11.23-21.13A11.19,11.19,0,0,1,367.54,149.07Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.92,
    cy: 151.43,
    r: 12.31,
    transform: "translate(171.04 494.68) rotate(-83.44)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.55,149.42c9-5.92,22.8-9.14,19.8-18.34-2.42-7.41-13.49-7.76-22-4.29C340.68,131.51,345.56,155.33,354.55,149.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,136.28a.48.48,0,0,1-.4-.21l-9.48-13.19a.51.51,0,0,1,.82-.59l9.47,13.2a.5.5,0,0,1-.11.69A.47.47,0,0,1,366,136.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.79,139.61a.52.52,0,0,1-.29-.09.5.5,0,0,1-.12-.7l9.47-13.19a.5.5,0,1,1,.82.58l-9.48,13.2A.49.49,0,0,1,371.79,139.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 370.58,
    cy: 143.77,
    rx: 14.28,
    ry: 11.51,
    transform: "translate(-20.06 217.23) rotate(-31.86)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.62,227.23s2.83,62.23,3.38,87.43c.56,26.22.81,87.44.81,87.44h6.62s10.55-50.88,7.43-87.44c4.72-28.07,7.91-87.43,7.91-87.43Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.39,227.23s15.76,65.17,22.21,89.54c6.77,25.59,15.91,83.43,16,85.33h5.72s1.8-66.82-7.25-89.54c0-28.47-11.85-85.33-11.85-85.33Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.51,400.5c4.88-.81,4.87,1.57,5.28,4.13a7,7,0,0,1-.65,4.52c-1.63,2.86,0,7.09-5.51,7.09s-6.05-1.2-4.65-3.76a27.36,27.36,0,0,0,2.62-8.22C384.88,402.78,385.34,400.86,387.51,400.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.49,405.32c.12,3.3.44,10.92.44,10.92l-.87,0s-1-8.12-1.59-10.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.54,151.9a6,6,0,0,1-3.24,3.22c-2,.79-3.16-.9-2.81-2.86.31-1.77,1.71-4.3,3.76-4.25A2.7,2.7,0,0,1,353.54,151.9Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.93,311.57c0,1.08.05,2.11.07,3.09.09,4,.17,8.93.24,14.29l15.16-3.6c-.07-3.65-.25-7.24-.54-10.69.3-1.81.6-3.75.9-5.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M384,312.56c0-2.51-.1-5.24-.27-8.14l-16.63,2.84c.92,3.58,1.75,6.8,2.47,9.51q.66,2.49,1.34,5.36l15-3.56A51.56,51.56,0,0,0,384,312.56Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M338.62,227.23l1,99.1,47-10c.74-56.55-3.67-76.11-14.42-89.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.27,251.69s-9.14,7.6-20.34,10.12C361.6,260.92,367.52,257.64,370.27,251.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.35,221a61,61,0,0,0,.63,6.37c.06.6.23,5.18.42,6.22s38.57.43,37.81-1.16-3.23-4.84-3.23-5.54-.26-5.87-.58-6.3S337.54,219.38,337.35,221Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.35,221a61,61,0,0,0,.63,6.37c.06.6.23,5.18.42,6.22s38.57.43,37.81-1.16-3.23-4.84-3.23-5.54-.26-5.87-.58-6.3S337.54,219.38,337.35,221Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.78,399.69c-1.72,4.95-6.7,13.77-6.7,13.77l9.45-2.61,4.64-7.29-1-1.92Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.58,401.09a5.79,5.79,0,0,1,.56,2.71c-.06,3.39-.44,12.4-.44,12.4h-.79a79.92,79.92,0,0,0-.42-8.3c-.4-2.24-1.37,1.71-2.87,3.93s-4.44,4.25-9.62,4.37c-6.06.15-8.51-.12-6.75-1.59S336,412.2,336,412.2a9.4,9.4,0,0,0,8-4.89c1.8-3.25,4-6.48,5.49-7.24A1.66,1.66,0,0,1,350.58,401.09Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailan);
export default __webpack_public_path__ + "static/media/Tailan.f0a887eb6f2192c416d7c1f92723a51a.svg";
export { ForwardRef as ReactComponent };